// Curated inspirational quotes for habit building
// All quotes are verified from books, speeches, or documented sources

const quotes = [
  // James Clear - Atomic Habits (2018)
  { text: "You do not rise to the level of your goals. You fall to the level of your systems.", author: "James Clear" },
  { text: "Every action you take is a vote for the type of person you wish to become.", author: "James Clear" },
  { text: "Habits are the compound interest of self-improvement.", author: "James Clear" },
  { text: "The task of breaking a bad habit is like uprooting a powerful oak within us.", author: "James Clear" },
  { text: "You should be far more concerned with your current trajectory than with your current results.", author: "James Clear" },
  { text: "Success is the product of daily habits. Not once-in-a-lifetime transformations.", author: "James Clear" },
  
  // David Goggins - Can't Hurt Me (2018) & interviews
  { text: "The only way to grow is to embrace the things you don't want to do.", author: "David Goggins" },
  { text: "You are in danger of living a life so comfortable and soft that you will die without ever realizing your potential.", author: "David Goggins" },
  { text: "Motivation is crap. Motivation comes and goes. When you're driven, whatever is in front of you will get destroyed.", author: "David Goggins" },
  { text: "The most important conversations you'll ever have are the ones you'll have with yourself.", author: "David Goggins" },
  { text: "We live in a world where mediocrity is often rewarded. Don't be that person.", author: "David Goggins" },
  { text: "Suffering is a test. That's all it is. Suffering is the true test of life.", author: "David Goggins" },
  
  // Alan Watts - Lectures & Books
  { text: "The only way to make sense out of change is to plunge into it, move with it, and join the dance.", author: "Alan Watts" },
  { text: "This is the real secret of life: to be completely engaged with what you are doing in the here and now.", author: "Alan Watts" },
  { text: "Muddy water is best cleared by leaving it alone.", author: "Alan Watts" },
  { text: "No valid plans for the future can be made by those who have no capacity for living now.", author: "Alan Watts" },
  { text: "The more a thing tends to be permanent, the more it tends to be lifeless.", author: "Alan Watts" },
  { text: "You are a function of what the whole universe is doing in the same way that a wave is a function of what the whole ocean is doing.", author: "Alan Watts" },
  
  // Seneca - Letters from a Stoic, On the Shortness of Life
  { text: "We suffer more often in imagination than in reality.", author: "Seneca" },
  { text: "It is not that we have a short time to live, but that we waste a lot of it.", author: "Seneca" },
  { text: "Luck is what happens when preparation meets opportunity.", author: "Seneca" },
  { text: "Begin at once to live, and count each separate day as a separate life.", author: "Seneca" },
  { text: "Difficulties strengthen the mind, as labor does the body.", author: "Seneca" },
  { text: "The whole future lies in uncertainty: live immediately.", author: "Seneca" },
  
  // Marcus Aurelius - Meditations
  { text: "You have power over your mind, not outside events. Realize this, and you will find strength.", author: "Marcus Aurelius" },
  { text: "Waste no more time arguing about what a good man should be. Be one.", author: "Marcus Aurelius" },
  { text: "The impediment to action advances action. What stands in the way becomes the way.", author: "Marcus Aurelius" },
  { text: "Very little is needed to make a happy life; it is all within yourself, in your way of thinking.", author: "Marcus Aurelius" },
  { text: "When you arise in the morning, think of what a precious privilege it is to be alive.", author: "Marcus Aurelius" },
  
  // Aristotle - Nicomachean Ethics
  { text: "We are what we repeatedly do. Excellence, then, is not an act, but a habit.", author: "Will Durant (on Aristotle)" },
  { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
  { text: "Knowing yourself is the beginning of all wisdom.", author: "Aristotle" },
  
  // Lao Tzu - Tao Te Ching
  { text: "A journey of a thousand miles begins with a single step.", author: "Lao Tzu" },
  { text: "Nature does not hurry, yet everything is accomplished.", author: "Lao Tzu" },
  { text: "He who conquers others is strong; he who conquers himself is mighty.", author: "Lao Tzu" },
  { text: "When I let go of what I am, I become what I might be.", author: "Lao Tzu" },
  
  // Buddha - Dhammapada
  { text: "What you think, you become. What you feel, you attract. What you imagine, you create.", author: "Buddha" },
  { text: "Do not dwell in the past, do not dream of the future, concentrate the mind on the present moment.", author: "Buddha" },
  { text: "An idea that is developed and put into action is more important than an idea that exists only as an idea.", author: "Buddha" },
  
  // Ralph Waldo Emerson
  { text: "The only person you are destined to become is the person you decide to be.", author: "Ralph Waldo Emerson" },
  { text: "What lies behind us and what lies before us are tiny matters compared to what lies within us.", author: "Ralph Waldo Emerson" },
  { text: "Sow a thought and you reap an action; sow an act and you reap a habit; sow a habit and you reap a character; sow a character and you reap a destiny.", author: "Ralph Waldo Emerson" },
  
  // Viktor Frankl - Man's Search for Meaning (1946)
  { text: "Between stimulus and response there is a space. In that space is our power to choose our response.", author: "Viktor Frankl" },
  { text: "When we are no longer able to change a situation, we are challenged to change ourselves.", author: "Viktor Frankl" },
  { text: "Those who have a 'why' to live, can bear with almost any 'how'.", author: "Viktor Frankl" },
  
  // William James - Psychology
  { text: "The greatest weapon against stress is our ability to choose one thought over another.", author: "William James" },
  { text: "Act as if what you do makes a difference. It does.", author: "William James" },
  
  // Modern wisdom
  { text: "Discipline equals freedom.", author: "Jocko Willink" },
  { text: "How you do anything is how you do everything.", author: "T. Harv Eker" },
  { text: "Small disciplines repeated with consistency every day lead to great achievements gained slowly over time.", author: "John C. Maxwell" },
  
  // Miyamoto Musashi - The Book of Five Rings
  { text: "Today is victory over yourself of yesterday; tomorrow is your victory over lesser men.", author: "Miyamoto Musashi" },
  { text: "There is nothing outside of yourself that can ever enable you to get better, stronger, richer, quicker, or smarter. Everything is within.", author: "Miyamoto Musashi" },
];

// Get a deterministic quote based on date and optional userId
// Same user sees same quote all day, but different users see different quotes
export const getDailyQuote = (userId = '') => {
  const today = new Date();
  const dateString = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`;
  
  // Create a simple hash from date + userId
  let hash = 0;
  const seed = dateString + userId;
  for (let i = 0; i < seed.length; i++) {
    const char = seed.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Use absolute value and modulo to get index
  const index = Math.abs(hash) % quotes.length;
  return quotes[index];
};

// Get a random quote (for refresh functionality if ever needed)
export const getRandomQuote = () => {
  return quotes[Math.floor(Math.random() * quotes.length)];
};

// Get a quote with salt for refresh - re-hashes userId with a random salt
export const getQuoteWithSalt = (userId = '', salt = 0) => {
  const today = new Date();
  const dateString = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`;
  
  // Create a hash from date + userId + salt
  let hash = 0;
  const seed = dateString + userId + salt.toString();
  for (let i = 0; i < seed.length; i++) {
    const char = seed.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  
  const index = Math.abs(hash) % quotes.length;
  return quotes[index];
};

export default quotes;
